<svg #svgEl class="tracker-svg" preserveAspectRatio="none">
  <path #pathEl
    [attr.d]="pathD"
    fill="none"
    [attr.stroke-width]="STROKE_WIDTH_PX"
    stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
